<script>
import axios from 'axios'
import store from '@state/store'
import OtpInput from '@components/otp-input.vue'
import { authComputed } from '@state/helpers'

export default {
  page: {
    title: 'Verify',
    meta: [{ name: 'description', content: 'The Verify page.' }],
  },
  components: { OtpInput },
  props: {
    routeTo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      field1: '',
      field2: '',
      field3: '',
      field4: '',
      field5: '',
      field6: '',
      tryingToVerify: false,
      authError: null,
      showHealthBookProfile: '',
    }
  },
  computed: {
    ...authComputed,
    verificationCode() {
      if (
        isNaN(parseInt(this.field1)) ||
        isNaN(parseInt(this.field2)) ||
        isNaN(parseInt(this.field3)) ||
        isNaN(parseInt(this.field4)) ||
        isNaN(parseInt(this.field5)) ||
        isNaN(parseInt(this.field6))
      ) {
        return ''
      }
      return (
        this.field1 +
        this.field2 +
        this.field3 +
        this.field4 +
        this.field5 +
        this.field6
      )
    },
    isUserProfessional() {
      return (
        this.serializedUser &&
        Object.prototype.hasOwnProperty.call(this.serializedUser, 'roles') &&
        Object.prototype.hasOwnProperty.call(
          this.serializedUser.roles,
          'professional'
        )
      )
    },
    getProfile() {
      if (this.showHealthBookProfile === 'professional') {
        return 'professional'
      } else {
        return 'patient'
      }
    },
  },
  methods: {
    // Try to verify the user in with the 2fa
    // code they provided.
    async tryToVerify(code) {
      const self = this
      self.tryingToVerify = true
      // Reset the authError if it existed.
      self.authError = null
      try {
        const { data } = await axios.post('/api/v1/verify/', {
          code: code,
        })
        if (data) {
          self.tryingToVerify = false
          const valid = await store.dispatch('auth/setCurrentUser', data)

          if (valid) {
            this.$router.push({ name: 'safehaven-dashboard' })
          } else {
            this.$router.push({ name: 'login' })
          }
        }
      } catch (error) {
        this.tryingToVerify = false
        this.authError = error
      }
    },
    goBack() {
      this.$router.push({ name: 'safeHavenLogout' })
    },
  },
}
</script>

<template>
  <v-container fluid style="height: 300px !important">
    <v-container :class="$style.innerContainer">
      <v-row
        no-gutters
        :class="$style.title"
        class="input--text"
        justify="center"
        style="color: black !important"
      >
        2-step verification
      </v-row>
      <v-row
        no-gutters
        :class="$style.subtitle"
        class="input--text"
        justify="center"
        style="color: black !important"
      >
        A verification code was send to your email. Please enter it below to
        continue to your account
      </v-row>
      <v-row no-gutters justify="center">
        <OtpInput
          :disabled="tryingToVerify"
          :class="authError ? $style.invalid : ''"
          @input="tryToVerify"
        ></OtpInput>
      </v-row>
      <v-row v-if="authError" no-gutters justify="start">
        <p class="alert alert-danger mt-5" role="alert">
          There was an error logging in to your account.
          <br />
          <strong>{{ authError.response.data }}</strong>
        </p>
      </v-row>
    </v-container>
    <!-- terms row -->
    <v-row :class="$style.termsRow" align="center" no-gutters>
      <v-col cols="12" md="6" class="d-flex justify-start">
        <div
          class="pl-4 pt-2 clickable primary--text"
          :class="$style.hrRouterLinkText"
          style="color: white !important"
          @click="goBack"
          ><v-icon color="white">mdi-chevron-left</v-icon> Back</div
        >
      </v-col>
      <!-- <v-col cols="12" md="6" class="d-flex justify-end">
        <a
          href="./privacy.pdf"
          target="_blank"
          class="mr-5 input--text text-decoration-none"
          :class="$style.termsPrivacy"
          >Privacy</a
        >
        <a
          href="./terms.pdf"
          target="_blank"
          class="input--text text-decoration-none"
          :class="$style.termsPrivacy"
          >Terms</a
        >
      </v-col> -->
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.invalid {
  /* also need animation and -moz-animation */
  -webkit-animation: shake 0.5s linear;
}

/* also need keyframes and -moz-keyframes */
@-webkit-keyframes shake {
  8%,
  41% {
    -webkit-transform: translateX(-10px);
  }
  25%,
  58% {
    -webkit-transform: translateX(10px);
  }
  75% {
    -webkit-transform: translateX(-5px);
  }
  92% {
    -webkit-transform: translateX(5px);
  }
  0%,
  100% {
    -webkit-transform: translateX(0);
  }
}

.container {
  display: grid;
  place-items: center;
  min-height: 900px;
}

.innerContainer {
  max-width: 400px;
  margin-bottom: 250px;
}

.title {
  margin-bottom: 25px !important;
  font-size: 32px;
  font-weight: 400;
  line-height: 48px;
  color: black !important;
  letter-spacing: 1px;
}

.subtitle {
  margin-bottom: 25px !important;
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.25px;
}

.termsRow {
  position: absolute;
  right: 0;
  bottom: 10px;
  width: 100%;
}

.termsPrivacy {
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 1px;
}

.hrRouterLinkText {
  font-family: $system-default-font-family;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 1px;
}
</style>
